var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconControlPanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 7.285H7.82c-.23-.426-.66-.714-1.153-.714s-.923.288-1.155.714H3.333c-.368 0-.666.321-.666.715 0 .395.298.714.666.714h2.18c.23.427.661.714 1.154.714.493 0 .923-.287 1.153-.714h4.847c.368 0 .666-.32.666-.714 0-.394-.298-.715-.666-.715m0 4.294h-1.509c-.23-.431-.662-.722-1.158-.722-.496 0-.928.29-1.158.722H3.333c-.368 0-.666.32-.666.714 0 .394.298.714.666.714H8.85c.232.422.66.707 1.15.707.49 0 .918-.285 1.15-.707h1.517c.368 0 .666-.32.666-.714 0-.395-.298-.714-.666-.714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.143H2c-.367 0-.666-.32-.666-.714v-10h13.332v10c0 .394-.299.714-.666.714M14 .857H2C.898.857 0 1.819 0 3v11.429c0 1.181.898 2.143 2 2.143h12c1.102 0 2-.962 2-2.143V2.999c0-1.18-.898-2.142-2-2.142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlPanel);
export default __webpack_public_path__ + "static/media/icon_control_panel.a6179e6fc1d9c79fea70d4a21527862d.svg";
export { ForwardRef as ReactComponent };